import { AuthFormStep, } from '@as-react/common-types';
import { AnalyticsActionTypes, SearchActionTypes } from '../../../enums/ActionEnums';
import { ReturnPortalEventActionType, } from '../../../enums/AnalyticsEnums';
export const analyticsActions = {
    digitalPartnerEnrolmentStepAuth(step, analyticsDigitalPartner) {
        switch (step.to) {
            case AuthFormStep.LOGIN:
                return {
                    type: AnalyticsActionTypes.DPE_ENROLMENT_AUTH_LOGIN,
                    payload: analyticsDigitalPartner,
                };
            case AuthFormStep.REGISTRATION:
                return {
                    type: AnalyticsActionTypes.DPE_ENROLMENT_AUTH_REGISTER,
                    payload: analyticsDigitalPartner,
                };
            case AuthFormStep.PASSWORD_FORGOTTEN:
                return {
                    type: AnalyticsActionTypes.DPE_ENROLMENT_AUTH_PASSWORD_FORGOTTEN,
                    payload: analyticsDigitalPartner,
                };
        }
        return {
            type: AnalyticsActionTypes.DPE_ENROLMENT_AUTH_EMAIL,
            payload: analyticsDigitalPartner,
        };
    },
    digitalPartnerEnrolmentStart(analyticsDigitalPartner) {
        return {
            type: AnalyticsActionTypes.DPE_ENROLMENT_START,
            payload: analyticsDigitalPartner,
        };
    },
    digitalPartnerEnrolmentStepAuthEmail(analyticsDigitalPartner) {
        return {
            type: AnalyticsActionTypes.DPE_ENROLMENT_AUTH_EMAIL,
            payload: analyticsDigitalPartner,
        };
    },
    digitalPartnerEnrolmentStepAuthLogin(analyticsDigitalPartner) {
        return {
            type: AnalyticsActionTypes.DPE_ENROLMENT_AUTH_LOGIN,
            payload: analyticsDigitalPartner,
        };
    },
    digitalPartnerEnrolmentStepAuthRegister(analyticsDigitalPartner) {
        return {
            type: AnalyticsActionTypes.DPE_ENROLMENT_AUTH_REGISTER,
            payload: analyticsDigitalPartner,
        };
    },
    digitalPartnerEnrolmentStepAuthPasswordForgotten(analyticsDigitalPartner) {
        return {
            type: AnalyticsActionTypes.DPE_ENROLMENT_AUTH_PASSWORD_FORGOTTEN,
            payload: analyticsDigitalPartner,
        };
    },
    digitalPartnerEnrolmentStepEligibilityCheck(analyticsDigitalPartner) {
        return {
            type: AnalyticsActionTypes.DPE_ENROLMENT_ELIGIBILITY_CHECK,
            payload: analyticsDigitalPartner,
        };
    },
    digitalPartnerEnrolmentStepConfirmation(analyticsDigitalPartner) {
        return {
            type: AnalyticsActionTypes.DPE_ENROLMENT_CONFIRMATION,
            payload: analyticsDigitalPartner,
        };
    },
    digitalPartnerEnrolmentLeave(analyticsDigitalPartner) {
        return {
            type: AnalyticsActionTypes.DPE_ENROLMENT_LEAVE,
            payload: analyticsDigitalPartner,
        };
    },
    formsErrorMessage(errorMessages) {
        return {
            type: AnalyticsActionTypes.FORMS_ERROR_MESSAGE,
            payload: errorMessages,
        };
    },
    searchUpdatedOnSiteSearchValue(searchValue) {
        return {
            type: AnalyticsActionTypes.SEARCH_ON_SITE_SEARCH_UPDATE,
            payload: searchValue,
        };
    },
    cookieConsentAcceptAll(consentSettings) {
        return {
            type: AnalyticsActionTypes.CONSENT_ACCEPT_ALL,
            payload: consentSettings,
        };
    },
    cookieConsentDeclineAll(consentSettings) {
        return {
            type: AnalyticsActionTypes.CONSENT_DECLINE_ALL,
            payload: consentSettings,
        };
    },
    cookieConsentUpdated(consentSettings) {
        return {
            type: AnalyticsActionTypes.CONSENT_UPDATE_PREFERENCES,
            payload: consentSettings,
        };
    },
    cookieConsentOpenPreferences(consentSettings) {
        return {
            type: AnalyticsActionTypes.CONSENT_OPEN_PREFERENCES,
            payload: consentSettings,
        };
    },
    loginStepOption(isNewCustomer) {
        return {
            type: AnalyticsActionTypes.LOGIN_STEP_OPTION,
            payload: isNewCustomer,
        };
    },
    checkoutStep(checkoutStep) {
        return {
            type: AnalyticsActionTypes.CHECKOUT_STEP,
            payload: checkoutStep,
        };
    },
    registrationStep() {
        return {
            type: AnalyticsActionTypes.REGISTRATION_STEP,
        };
    },
    deliveryStep(deliveryOption) {
        return {
            type: AnalyticsActionTypes.DELIVERY_STEP,
            payload: deliveryOption,
        };
    },
    deliveryStepOption(deliveryOption) {
        return {
            type: AnalyticsActionTypes.DELIVERY_STEP_OPTION,
            payload: deliveryOption,
        };
    },
    paymentRequest(paymentRequest) {
        return {
            type: AnalyticsActionTypes.PAYMENT_REQUEST,
            payload: paymentRequest,
        };
    },
    paymentStep(chosenPaymentOption) {
        return {
            type: AnalyticsActionTypes.PAYMENT_STEP,
            payload: chosenPaymentOption,
        };
    },
    paymentStepOption(paymentOption) {
        return {
            type: AnalyticsActionTypes.PAYMENT_STEP_OPTION,
            payload: paymentOption,
        };
    },
    voucherAdded(code) {
        return {
            type: AnalyticsActionTypes.VOUCHER_ADDED,
            payload: code,
        };
    },
    googleConfirmationPage(payload) {
        return {
            type: AnalyticsActionTypes.ANALYTICS_GOOGLE_CONFIRMATION_PAGE,
            payload,
        };
    },
    confirmationPage() {
        return {
            type: AnalyticsActionTypes.CONFIRMATION_PAGE,
        };
    },
    filterWizardOpened(payload) {
        return {
            type: AnalyticsActionTypes.FILTER_WIZARD_OPENED,
            payload,
        };
    },
    filterWizardSelected(payload) {
        return {
            type: AnalyticsActionTypes.FILTER_WIZARD_SELECTED,
            payload,
        };
    },
    checkoutType(payload) {
        return {
            type: AnalyticsActionTypes.CHECKOUT_TYPE,
            payload,
        };
    },
    compareProductsFeatures(payload) {
        return {
            type: AnalyticsActionTypes.COMPARE_PRODUCTS_FEATURES,
            payload,
        };
    },
    productSearchPersonalization(payload) {
        return {
            type: AnalyticsActionTypes.PRODUCT_SEARCH_PERSONALIZATION,
            payload,
        };
    },
    storeFilterStarted() {
        return {
            type: AnalyticsActionTypes.STORE_FILTER_STARTED,
        };
    },
    storeFilterApplied() {
        return {
            type: AnalyticsActionTypes.STORE_FILTER_APPLIED,
        };
    },
    storeFilterModified() {
        return {
            type: AnalyticsActionTypes.STORE_FILTER_MODIFIED,
        };
    },
    shopTheLookOpened(payload) {
        return {
            type: AnalyticsActionTypes.SHOP_THE_LOOK_OPENED,
            payload,
        };
    },
    createTileClickAction: () => ({
        type: AnalyticsActionTypes.LISTER_TILE_CLICK,
    }),
    listerSortChange(payload) {
        return {
            type: AnalyticsActionTypes.LISTER_SORT_CHANGE,
            payload,
        };
    },
    newsletterPreferencesSubscriptionUpdate(payload) {
        return {
            type: AnalyticsActionTypes.NEWSLETTER_PREFERENCES_SUBSCRIPTION_UPDATE,
            payload,
        };
    },
    newsletterPreferencesSubscribe(payload) {
        return {
            type: AnalyticsActionTypes.NEWSLETTER_PREFERENCES_SUBSCRIBE,
            payload,
        };
    },
    newsletterPreferencesUnsubscribe(payload) {
        return {
            type: AnalyticsActionTypes.NEWSLETTER_PREFERENCES_UNSUBSCRIBE,
            payload,
        };
    },
    newsletterPreferencesUpdate(payload) {
        return {
            type: AnalyticsActionTypes.NEWSLETTER_PREFERENCES_UPDATE,
            payload,
        };
    },
    returnPortalLogin(payload) {
        return {
            type: AnalyticsActionTypes.RETURN_PORTAL_LOGIN,
            payload,
        };
    },
    returnPortalReturnOverviewOpened(hasItems) {
        return {
            type: AnalyticsActionTypes.RETURN_PRODUCT_OVERVIEW,
            payload: hasItems,
        };
    },
    returnPortalAnnouncedOverviewOpened() {
        return {
            type: AnalyticsActionTypes.RETURN_PRODUCT_OVERVIEW,
        };
    },
    returnProductsContinueClicked() {
        return {
            type: AnalyticsActionTypes.RETURN_PRODUCTS_CONTINUE_CLICK,
            payload: {
                eventAction: ReturnPortalEventActionType.CONTINUE_TO_METHOD,
            },
        };
    },
    returnProductSelected() {
        return {
            type: AnalyticsActionTypes.RETURN_PRODUCT_SELECTED,
            payload: {
                eventAction: ReturnPortalEventActionType.SELECT_PRODUCT,
            },
        };
    },
    returnProductUnselected() {
        return {
            type: AnalyticsActionTypes.RETURN_PRODUCT_UNSELECTED,
            payload: {
                eventAction: ReturnPortalEventActionType.UNSELECT_PRODUCT,
            },
        };
    },
    returnMethodOverviewOpened() {
        return {
            type: AnalyticsActionTypes.RETURN_METHOD_OVERVIEW,
        };
    },
    returnMethodConfirmClickClicked(returnMethod) {
        return {
            type: AnalyticsActionTypes.RETURN_METHOD_CONFIRM_CLICK,
            payload: {
                eventAction: ReturnPortalEventActionType.CONFIRM_RETURN_METHOD,
                returnMethod,
            },
        };
    },
    returnMethodSelected(returnMethod) {
        return {
            type: AnalyticsActionTypes.RETURN_METHOD_SELECTED,
            payload: {
                eventAction: ReturnPortalEventActionType.SELECT_RETURN_METHOD,
                returnMethod,
            },
        };
    },
    returnAnnounced(returnMethod) {
        return {
            type: AnalyticsActionTypes.RETURN_ANNOUNCED,
            payload: {
                returnMethod,
            },
        };
    },
    showStoreStock() {
        return {
            type: AnalyticsActionTypes.SHOW_STORE_STOCK,
        };
    },
    productDetailTabOpen(payload) {
        return {
            type: AnalyticsActionTypes.PRODUCT_DETAIL_TAB_OPEN,
            payload,
        };
    },
    productDetailSizeGuideClick(pdpTemplateName) {
        return {
            type: AnalyticsActionTypes.PRODUCT_DETAIL_SIZE_GUIDE_CLICK,
            payload: pdpTemplateName,
        };
    },
    productDetailAddToBasket(analyticsAdobeTagManagerData, additionalProducts) {
        return {
            type: AnalyticsActionTypes.PRODUCT_DETAIL_ADD_TO_BASKET,
            payload: {
                analyticsAdobeTagManagerData,
                additionalProducts,
            },
        };
    },
    productDetailCarouselImageViewed(payload) {
        return {
            type: AnalyticsActionTypes.PRODUCT_DETAIL_CAROUSEL_IMAGE_VIEWED,
            payload,
        };
    },
    listerResults(payload) {
        return {
            type: AnalyticsActionTypes.LISTER_RESULTS,
            payload,
        };
    },
    listerViewProductList(items, currency, event, searchTerm) {
        return {
            type: AnalyticsActionTypes.LISTER_VIEW_PRODUCT_LIST,
            payload: { items, currency, event, searchTerm },
        };
    },
    giftVoucherInit(payload) {
        return {
            type: AnalyticsActionTypes.GIFT_VOUCHER_INIT,
            payload,
        };
    },
    customerIdentification(payload) {
        return {
            type: AnalyticsActionTypes.CUSTOMER_IDENTIFICATION,
            payload,
        };
    },
    additionalProductSelector(products) {
        return {
            type: AnalyticsActionTypes.ADDITIONAL_PRODUCT_SELECTOR_VIEWED,
            payload: products,
        };
    },
    bundleDealsViewed(colorId) {
        return {
            type: AnalyticsActionTypes.BUNDLE_DEALS_VIEWED,
            payload: colorId,
        };
    },
    basketReminderNotificationViewed() {
        return {
            type: AnalyticsActionTypes.BASKET_REMINDER_NOTIFICATION_VIEWED,
        };
    },
    basketReminderNotificationEvent(payload) {
        return {
            type: AnalyticsActionTypes.BASKET_REMINDER_NOTIFICATION_EVENT,
            payload,
        };
    },
    faqQuestionExpand(title) {
        return {
            type: AnalyticsActionTypes.FAQ_QUESTION_EXPAND,
            payload: title,
        };
    },
    notifyMeRequest() {
        return {
            type: AnalyticsActionTypes.NOTIFY_ME_REQUEST,
        };
    },
    applePayClick() {
        return {
            type: AnalyticsActionTypes.APPLE_PAY_CLICK,
        };
    },
    applePayButtonInitialInViewport(payload) {
        return {
            type: AnalyticsActionTypes.APPLE_PAY_BUTTON_INITIAL_IN_VIEWPORT,
            payload,
        };
    },
    applePayButtonImpression(payload) {
        return {
            type: AnalyticsActionTypes.APPLE_PAY_BUTTON_IMPRESSION,
            payload,
        };
    },
    eTicketSendFeedback() {
        return {
            type: AnalyticsActionTypes.ETICKET_SEND_FEEDBACK,
        };
    },
    paybackEnrichmentChanged(hasChanged) {
        return {
            type: AnalyticsActionTypes.PAYBACK_ENRICHMENT_CHANGED,
            payload: { hasChanged },
        };
    },
    paybackError(analyticsError) {
        return {
            type: AnalyticsActionTypes.PAYBACK_ERROR,
            payload: { analyticsError },
        };
    },
    productGroupViewed(payload) {
        return {
            type: AnalyticsActionTypes.PRODUCT_GROUP_VIEWED,
            payload,
        };
    },
    productGroupItemClick(payload) {
        return {
            type: AnalyticsActionTypes.PRODUCT_GROUP_ITEM_CLICK,
            payload,
        };
    },
    productVariantClick() {
        return {
            type: AnalyticsActionTypes.PRODUCT_VARIANT_CLICK,
        };
    },
    productVideoLoaded(payload) {
        return {
            type: AnalyticsActionTypes.PRODUCT_DETAILS_VIDEO_LOADED,
            payload,
        };
    },
    blockedCheckout(payload) {
        return {
            type: AnalyticsActionTypes.BLOCKED_CHECKOUT,
            payload,
        };
    },
    mobileNavigationClick() {
        return {
            type: AnalyticsActionTypes.MOBILE_NAVIGATION_CLICK,
        };
    },
    sizebayClick(payload) {
        return {
            type: AnalyticsActionTypes.SIZEBAY_CLICK,
            payload,
        };
    },
    checkoutPersonalDetails() {
        return {
            type: AnalyticsActionTypes.CHECKOUT_PERSONAL_DETAILS,
        };
    },
    createFetchWithoutProductsAction(value) {
        return {
            type: SearchActionTypes.FETCH_WITHOUT_PRODUCTS,
            payload: value,
        };
    },
    createAdobeAnalyticsSetSearchTermAction(payload) {
        return {
            type: SearchActionTypes.ADOBE_ANALYTICS_SET_SEARCH_TERM,
            payload,
        };
    },
};
